'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorFormatColorReset = function EditorFormatColorReset(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z' })
  );
};
EditorFormatColorReset = (0, _pure2.default)(EditorFormatColorReset);
EditorFormatColorReset.displayName = 'EditorFormatColorReset';
EditorFormatColorReset.muiName = 'SvgIcon';

exports.default = EditorFormatColorReset;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/format-color-reset.js
 ** module id = 1913
 ** module chunks = 0
 **/